export const getNumber = (maybeNumber: unknown) => {
  if (typeof maybeNumber === 'number') return maybeNumber;

  return parseFloat(maybeNumber as any);
};
